export default function useErpApi() {
  const {
    getWidths,
    getProfiles,
    getRings,
    getStock,
    getVerificarPrecios,
    getLocalesPorRegionPorComuna,
    getServices,
    getLogisticsRoutes,
    getServiceTime,
    getLogisticCalendar,
    getClient,
    storeClient,
    createPreOrder,
    confirmPreOrder,
    createPreOrderSecure,
    confirmPreOrderSecure,
    getPlpMulti,
    getPlpNeumaticosByLocal,
    getPlpBatteryByLocal,
    getPdpNeumaticosByLocal,
    get_locales_full,
    getPdpBatteryByLocal,
  } = useErpTouch();

  // Llamadas
  const getWidthsData = async () => {
    return await getWidths();
  };

  const getProfilesData = async (width) => {
    return await getProfiles(width);
  };

  const getRingsData = async (width, $profile) => {
    return await getRings(width, $profile);
  };

  const get_locales_full_erpapi = async () => {
    return await get_locales_full();
  };

  const getStoresDataPorRegionPorComuna = async (region, commune) => {
    return await getLocalesPorRegionPorComuna(region, commune);
  };

  //PLP DOBLE
  const getPlpMultiData = async (local, vehicle) => {
    return await getPlpMulti(local, vehicle);
  };

  const getStockData = async (products) => {
    return await getStock(products);
  };

  const verificarPrecios = async (productos, local_id) => {
    return await getVerificarPrecios(productos, local_id);
  };

  const getServicesData = async (local, business, ring, marcas = []) => {
    return await getServices(local, business, ring, marcas);
  };

  const getServicesBatteryData = async (local, carPlate) => {
    //console.log("llego a getServicesBatteryData");
    return await getServices(local, carPlate);
  };

  const getLogisticsRoutesData = async (store, products, businessId, modalidad) => {
    //console.log("DATOS: store, products, businessId, modalidad: ", store, products, businessId, modalidad);
    return await getLogisticsRoutes(store, products, businessId, modalidad);
  };

  const getServiceTimeData = async (store, business) => {
    return await getServiceTime(store, business);
  };

  const getLogisticCalendarData = async (store, business, minutes) => {
    return await getLogisticCalendar(store, business, minutes);
  };

  const getClientData = async (email) => {
    return await getClient(email);
  };

  const storeClientData = async (email, name, lastname, surname, phone, country) => {
    return await storeClient(email, name, lastname, surname, phone, country);
  };

  const createPreOrderData = async (data) => {
    return await createPreOrder(data);
  };

  const confirmPreOrderData = async (data) => {
    return await confirmPreOrder(data);
  };

  const createPreOrderDataSecure = async (data) => {
    return await createPreOrderSecure(data);
  };

  const confirmPreOrderDataSecure = async (data) => {
    return await confirmPreOrderSecure(data);
  };

  const getPlpByLocalData = async (local, width, profile, ring) => {
    const result = await getPlpNeumaticosByLocal(local, width, profile, ring);
    //console.log("primaria:", structuredClone(result));
    return result;
  };


  const getPlpBatteryByLocalData = async (local, carPlate, batteryInstallType) => {
    const response = await getPlpBatteryByLocal(local, carPlate, batteryInstallType);
    return response;
  };

  const getPdpByLocalData = async (local, code) => {
    return await getPdpNeumaticosByLocal(local, code);
  };

  const getPdpBatteryByLocalData = async (local, code, carPlate, batteryInstallType) => {
    return await getPdpBatteryByLocal(local, code, carPlate, batteryInstallType);
  };

  return {
    getWidthsData,
    getProfilesData,
    getRingsData,
    getStockData,
    verificarPrecios,
    getStoresDataPorRegionPorComuna,
    getServicesData,
    getServicesBatteryData,
    getLogisticsRoutesData,
    getServiceTimeData,
    getLogisticCalendarData,
    getClientData,
    storeClientData,
    createPreOrderData,
    confirmPreOrderData,
    createPreOrderDataSecure,
    confirmPreOrderDataSecure,
    getPlpMultiData,
    getPlpByLocalData,
    getPlpBatteryByLocalData,
    getPdpByLocalData,
    get_locales_full_erpapi,
    getPdpBatteryByLocalData,
  };
}
